export default "__VITE_ASSET__186093a2__"